import style from "./StockManagement.module.css";
import VerticalFlex from "layouts/flex/VerticalFlex";
import FlexChild from "layouts/flex/FlexChild";
import { useEffect, useState } from "react";
import { adminRequester } from "App";
import TableSearchCard from "routes/table/search/TableSearchCard";
import SingleAdminTable from "routes/admin/table/SingleAdminTable";
import P from "components/P";
import NiceModal from "@ebay/nice-modal-react";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import TableButton from "routes/admin/table/TableButton";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import clsx from "clsx";
import { t } from "i18next";
import ToolTip from "components/tooltip/tooltip";
import { et } from "date-fns/locale";

export const limit = 20;

function StockManagement(props) {
  const [count, setCount] = useState(0);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [maxPage, setMaxPage] = useState(0);
  const [searchCondition, setSearchCondition] = useState();
  const [reset, setReset] = useState(false);
  const [research, setResearch] = useState(false);
  const extraCondition = {};
  const navigate = useNavigate();
  const theader = [
    {
      width: 50,
      text: "No.",
      justifyContent: "flex-start",
      Cell: ({ index }) => index + 1,
    },
    {
      width: 100,
      text: "브랜드명",
      justifyContent: "flex-start",
      code: "product",
      Cell: ({ cell }) => cell.store?.name,
    },
    {
      width: 350,
      text: "상품/옵션명",
      justifyContent: "flex-start",
      code: "product",
      hover: true,
      cursor: true,
      Cell: ({ row, cell }) => (
        <HorizontalFlex gap={5} justifyContent="flex-start">
          {cell?.thumbnail && (
            <FlexChild width="max-content">
              <img
                src={cell.thumbnail}
                alt="empty"
                style={{ maxWidth: "50px", maxHeight: "50px" }}
              />
            </FlexChild>
          )}
          <VerticalFlex width="max-content" alignItems="flex-start">
            <HorizontalFlex width="max-content" gap={10}>
              <P
                hover
                cursor
                color="#00b5b8"
                onClick={() => {
                  navigator.clipboard.writeText(cell.id);
                  toast.success("상품코드를 복사했습니다", {
                    autoClose: 1000,
                    position: toast.POSITION.BOTTOM_CENTER,
                  });
                }}
              >
                {cell.title}
              </P>
              <ToolTip
                style={{
                  backgroundColor: "white",
                  width: "max-content",
                  padding: 10,
                }}
                title={
                  <VerticalFlex>
                    {row.options?.map((option, index) => (
                      <HorizontalFlex key={option.id} gap={10}>
                        {row.options.length > 1 && (
                          <FlexChild width="max-content">{index}</FlexChild>
                        )}
                        <FlexChild width="max-content">
                          <P>{option.option.title}</P>
                        </FlexChild>
                        <FlexChild width="max-content">
                          <P>({option.value})</P>
                        </FlexChild>
                      </HorizontalFlex>
                    ))}
                  </VerticalFlex>
                }
              >
                <P>{row.title}</P>
              </ToolTip>
            </HorizontalFlex>
            <FlexChild width="max-content">
              <P
                width={300}
                whiteSpace="nowrap"
                overflow="hidden"
                textOverflow="ellipsis"
                cursor
                hover
                onClick={() => {
                  navigator.clipboard.writeText(row.id);
                  toast.success("옵션코드를 복사했습니다", {
                    autoClose: 1000,
                    position: toast.POSITION.BOTTOM_CENTER,
                  });
                }}
              >
                {row.id}
              </P>
            </FlexChild>
          </VerticalFlex>
        </HorizontalFlex>
      ),
    },
    {
      width: 100,
      text: "상품현황",
      justifyContent: "flex-start",
      Cell: ({ row }) => {
        const status =
          row.sold || row.inventory_quantity === 0
            ? "status_out"
            : row.inventory_quantity < row.check
            ? "status_almost_out"
            : "status_normal";
        return <div>{t(status)}</div>;
      },
    },
    {
      width: 125,
      text: "재고관리 사용",
      justifyContent: "flex-start",
      code: "manage_inventory",
      Cell: ({ row, cell }) => (
        <select
          value={cell}
          onChange={(e) =>
            adminRequester.updateVariant(
              row.product.id,
              row.id,
              { manage_inventory: e.target.value === "true" ? true : false },
              () => setResearch(true)
            )
          }
        >
          <option value={true}>사용함</option>
          <option value={false}>사용안함</option>
        </select>
      ),
    },
    {
      width: 125,
      text: "품절 여부",
      justifyContent: "flex-start",
      code: "sold",
      Cell: ({ row, cell }) => (
        <select
          value={cell}
          onChange={(e) =>
            adminRequester.updateVariant(
              row.product.id,
              row.id,
              { sold: e.target.value === "true" ? true : false },
              () => setResearch(true)
            )
          }
        >
          <option value={true}>품절지정</option>
          <option value={false}>자동</option>
        </select>
      ),
    },
    {
      width: 75,
      text: "재고수량",
      justifyContent: "flex-start",
      code: "inventory_quantity",
      Cell: ({ row, cell }) => (
        <P>
          <input
            type="number"
            defaultValue={cell}
            style={{ width: 75 }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                adminRequester.updateVariant(
                  row.product.id,
                  row.id,
                  { inventory_quantity: Number(e.target.value) },
                  () => setResearch(true)
                );
              }
            }}
          />
        </P>
      ),
    },
    {
      width: 75,
      text: "안전재고",
      justifyContent: "flex-start",
      code: "check",
      Cell: ({ row, cell }) => (
        <P>
          <input
            type="number"
            defaultValue={cell}
            style={{ width: 75 }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                adminRequester.updateVariant(
                  row.product.id,
                  row.id,
                  { check: Number(e.target.value) },
                  () => setResearch(true)
                );
              }
            }}
          />
        </P>
      ),
    },
    {
      width: 120,
      text: "진열상태",
      justifyContent: "flex-start",
      code: "product",
      Cell: ({ cell }) =>
        cell?.status === "published" ? "전시중" : "비전시중",
    },
    {
      width: 120,
      text: "판매상태",
      justifyContent: "flex-start",
      code: "product",
      Cell: ({ cell }) => (cell?.buyable === true ? "판매중" : "구매불가"),
    },
    {
      width: "120",
      text: "누적판매",
      justifyContent: "flex-start",
    },
  ];
  const outputHeader = [
    {
      text: "No.",
      code: "index",
      Cell: ({ index }) => index,
    },
    {
      text: "브랜드명",
      code: "product",
      Cell: ({ cell }) => cell.store?.name,
    },
    {
      text: "상품명",
      code: "product",
      Cell: ({ cell }) => cell.title,
    },
    {
      text: "상품코드",
      code: "product",
      Cell: ({ cell }) => cell.id,
    },
    {
      text: "옵션명",
      code: "title",
    },
    {
      text: "옵션코드",
      code: "id",
    },
    {
      text: "상품현황",
      Cell: ({ row }) =>
        t(
          row.sold || row.inventory_quantity === 0
            ? "status_out"
            : row.inventory_quantity < row.check
            ? "status_almost_out"
            : "status_normal"
        ),
    },
    {
      text: "재고관리 사용",
      code: "manage_inventory",
      Cell: ({ cell }) => (cell === true ? "사용함" : "사용안함"),
    },
    {
      text: "품절 여부",
      code: "sold",
      Cell: ({ cell }) => (cell === true ? "품절지정" : "자동"),
    },
    {
      text: "재고수량",
      code: "inventory_quantity",
    },
    {
      text: "안전재고",
      code: "check",
    },
    {
      text: "진열상태",
      code: "product",
      Cell: ({ cell }) =>
        cell?.status === "published" ? "전시중" : "비전시중",
    },
    {
      text: "판매상태",
      code: "product",
      Cell: ({ cell }) => (cell?.buyable === true ? "판매중" : "구매불가"),
    },
    {
      width: "120",
      text: "누적판매",
      justifyContent: "flex-start",
    },
  ];
  const buttons = [
    { code: "stockAll", onSuccess: () => setResearch(true) },
    {
      code: "excelDownload",
      props: {
        fileName: "재고",
        header: outputHeader,
        onReload: async () => {
          const result = await adminRequester.getVariantStatus({
            ...extraCondition,
            ...searchCondition,
          });
          return result.variants;
        },
      },
    },
    {
      code: "excelUpload",
      onSuccess: (list) =>
        adminRequester.postVariantStatus({ list: list }, () =>
          setResearch(true)
        ),
      props: {
        label: "재고정보 업로드",
        header: [
          {
            code: "상품코드",
            attr: "pid",
          },
          {
            code: "옵션코드",
            attr: "vid",
          },
          { code: "재고관리 사용", attr: "manage_inventory" },
          {
            code: "품절 여부",
            attr: "sold",
          },
          {
            code: "재고수량",
            attr: "inventory_quantity",
          },
          {
            code: "안전재고",
            attr: "check",
          },
          {
            code: "진열상태",
            attr: "display",
          },
          {
            code: "판매상태",
            attr: "buyable",
          },
        ],
      },
    },
    { code: "empty" },
    { code: "mainDisplay", onSuccess: () => NiceModal.show("mainDisplay") },
    {
      code: "productRegist",
      onSuccess: () => navigate("/admin/productRegistration"),
    },
  ]
    .map((button) => TableButton(button.code, button?.onSuccess, button?.props))
    .filter((button) => !!button);

  useEffect(() => {
    adminRequester.getVariantStatus(
      {
        ...extraCondition,
        ...searchCondition,
        offset: page * limit,
        limit: limit,
      },
      (result) => {
        setCount(result.count);
        setMaxPage(result.count / limit);
        setData(result.variants);
      }
    );
  }, [page, searchCondition]);
  useEffect(() => {
    if (reset) {
      setData([]);
      setReset(false);
      setMaxPage(0);
      setCount(0);
    }
  }, [reset]);
  useEffect(() => {
    if (research) {
      adminRequester.getVariantStatus(
        {
          ...extraCondition,
          ...searchCondition,
          offset: page * limit,
          limit: limit,
        },
        (result) => {
          setCount(result.count);
          setMaxPage(result.count / limit);
          setData(result.variants);
        }
      );
      setResearch(false);
    }
  }, [research]);

  const callback = (searchCondition) => {
    setPage(0);
    setData([]);
    setSearchCondition(searchCondition);
  };

  const dataCallback = (value) => {
    setData(value);
  };
  const openEdit = ({ row }) => {
    NiceModal.show("variantStatus", {
      data: row,
      onSuccess: () => setResearch(true),
    });
  };

  const getOutput = (outputHeader) => {
    const output = async (data, indexes) => {
      let list;

      if (!indexes || indexes.length === 0) {
        list =
          (
            await adminRequester.getVariantStatus({
              ...extraCondition,
              ...searchCondition,
            })
          ).variants || [];
      } else {
        list = indexes.map((index) => ({
          ...data[index],
          // index: index + page * limit,
        }));
      }

      return {
        header: outputHeader,
        list: list,
        fileName: `상품_${new Date().getTime()}`,
      };
    };
    return output;
  };

  return (
    <div className={style.container}>
      <VerticalFlex>
        <FlexChild>
          <HorizontalFlex gap={10} justifyContent="flex-start">
            <FlexChild width="max-content">
              <div
                style={{
                  width: "100%",
                  textAlign: "left",
                  fontSize: 18,
                  paddingBottom: "8px",
                  fontWeight: "700",
                }}
              >
                {t("StockManagement")}
              </div>
            </FlexChild>
          </HorizontalFlex>
        </FlexChild>
        <FlexChild>
          <TableSearchCard
            callback={callback}
            index={1}
            reset={reset}
            setReset={setReset}
            research={research}
          />
        </FlexChild>
        <FlexChild>
          <SingleAdminTable
            theader={theader}
            count={count}
            mockData={data}
            initTabIndex={0}
            callback={dataCallback}
            output={{ getData: getOutput(outputHeader) }}
            page={page}
            buttons={buttons}
            buttonSplit
            maxPage={maxPage}
            setPage={setPage}
            limit={limit}
            reset={reset}
            research={research}
          />
        </FlexChild>
      </VerticalFlex>
    </div>
  );
}

export default StockManagement;
